import React from 'react';

export const useOnWindowResize = (callback, { delay = 250 } = {}) => {
  const fn = React.useCallback(callback, [callback]);

  React.useEffect(() => {
    let timeoutId;

    const handleResize = () => {
      if (timeoutId) clearTimeout(timeoutId);
      timeoutId = setTimeout(fn, delay);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [delay, fn]);
};
